import {appSelectors} from '@appStore/reducers/app'
import {useAppSelector} from 'shared/hooks'

export function useWebhookSubscription() {
	const appProfile = useAppSelector(appSelectors.appProfile)
	const subscriptionIsActive = useAppSelector(appSelectors.subscriptionIsActive)
	const isWebhooksEnabled = Boolean(
		subscriptionIsActive &&
		(appProfile?.isProPlanAccessible || appProfile?.isTeamPlanAccessible || appProfile?.isTrial)
	)

	return {
		isLoading: false,
		isWebhooksEnabled
	}
}
